// @flow
import cuckoo from "../cuckoo/cuckoo"
import { getTrackingEventFromAction } from "../../../mmb/services/tracking/actionTypesToEventsMapper"
import type { TrackedEventTypes } from "../../../mmb/services/tracking/actionTypesToEventsMapper"
import { get } from "common/utils/get"
import { mapActionTypeToDataDogEventName } from "mmb/services/datadog/datadogMapper"
import { cleanFilesForPayloadTracking } from "mmb/scenes/Booking/components/BookingFileUpload/BookingFileUploadHelpers"

export default () => (next: any => any) => (action: {
  type: TrackedEventTypes | string,
  original_type: string,
  _track?: { value?: any, event: string },
  action?: any,
  res?: any,
}) => {
  const track = action._track

  if (track) {
    const eventFromDictionary = getTrackingEventFromAction(action)

    if (eventFromDictionary) {
      const event = {
        category: "Manage", // currently promise middleware used only by MMB
        subCategory: eventFromDictionary.module,
        detail: eventFromDictionary.detail || undefined,
        ...eventFromDictionary.action,
      }

      if (action.type.endsWith("_REQUEST")) {
        cuckoo.track(
          { ...event, action: `${event.action} requested` },
          cleanFilesForPayloadTracking(track),
        )
      } else if (action.type.endsWith("_FAILURE")) {
        cuckoo.track({ ...event, action: `${event.action} failed` }, track)
      } else if (action.type.endsWith("_SUCCESS")) {
        cuckoo.track(
          { ...event, action: `${event.action} succeeded` },
          { result: action.res || undefined },
        )
      } else {
        cuckoo.track(event, cleanFilesForPayloadTracking(track))
      }
    } else {
      const eventName = mapActionTypeToDataDogEventName(action) || action.type

      if (typeof track === "string" && track[0] === "@") {
        const payload = get([track.substring(1)], action)
        cuckoo.track(String(eventName), payload)
      } else {
        cuckoo.track(String(eventName), cleanFilesForPayloadTracking(track))
      }
    }
  }

  // dispatch the original action
  return next(action)
}
